import { Promise } from 'es6-promise';
import { IDropdownOption } from 'office-ui-fabric-react';
import { getActionsFromService, getActionTemplate, IAction, getFieldTypesFromService, getEntityFieldsFromService, ModalHelper, SetOutputMethodType, IFieldConfig, IFieldDictionary, getEntityOptionSetFromService, getEntityViewsFromService } from './';
import store from '../store/store';
import types from '../store/types';
import { PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER } from '../constants/debounce';

export class ActionHelper {
	private static inputTimeout: any[];

	public static loadActionTypes(): Promise<any> {

		var promise = new Promise((resolve, reject) => {

			let cacheState = store.getState().cacheState;
			if (cacheState.actionTypes.length) {
				resolve(cacheState.actionTypes);
			}
			else {
				getActionsFromService().then(
					(actionNames: string[]) => {
						let actionTypes = actionNames.map((v) => {
							let option: IDropdownOption = {
								key: v,
								text: v
							};
							return option;
						});
						store.dispatch({
							type: types.SET_ACTION_TYPES,
							actionTypes: actionTypes
						});
						resolve(actionTypes);
					},
					(error) => {
						reject(error);
					}
				);
			}

		});

		return promise;
	}

	public static loadActionTemplate(name: string): Promise<IAction> {

		return getActionTemplate(name).then(actionTemplate => {

			store.dispatch({
				type: types.ADD_ACTION_TEMPLATE,
				actionTemplate: actionTemplate
			});

			return actionTemplate;
		});
	}

	public static getEntityOptionSet(entity: string): Promise<any> {

		return getEntityOptionSetFromService(entity).then(optionSet => {

			store.dispatch({
				type: types.ADD_ENTITY_OPTION_SET,
				actionTemplate: optionSet
			});

			return optionSet;
		});
	}

	public static getFieldTypes = (): Promise<any> => {

		var promise = new Promise((resolve, reject) => {

			let cacheState = store.getState().cacheState;
			if (cacheState.fieldTypes.length) {
				resolve(cacheState.fieldTypes);
			}
			else {

				getFieldTypesFromService().then(
					(fieldTypeNames: string[]) => {

						let fieldTypes = fieldTypeNames.map((o, i) => {
							return { key: i, text: o };
						});
						store.dispatch({
							type: types.SET_FIELD_TYPES,
							fieldTypes: fieldTypes
						});
						resolve(fieldTypes);

					},
					(error) => {
						reject(error);
					}
				);
			}

		});

		return promise;

	}

	// Set state values for the fields.
	public static updateFieldName = (index: number, name: string) => {
		store.dispatch({
			type: types.UPDATE_FIELD_NAME,
			index: index,
			name: name
		});
	}

	// Fetch fields for the selected entity
	public static loadEntityFields = (entity: string, componentId: string, onload?: boolean, fields?: IFieldDictionary): Promise<any> => {
		return getEntityFieldsFromService(entity).then((entityFields: any) => {

			// if the component that made the api call is different than the currently opened component, perform no operation and return
			if (componentId !== "00000000-0000-0000-0000-000000000000" && componentId !== (store.getState().modalState.actionConfig && store.getState().modalState.actionConfig.componentId)) {
				return;
			}

			// Filter fields by requiredFields
			let requiredFields = {};
			let optionalFields = {};
			var filteredFields;

			// If there is no error fetching the entity-related fields
			if (!entityFields.Error && entityFields.Error !== '') {

				Object.keys(entityFields).forEach(element => {
					const test = JSON.parse(entityFields[element]);
					entityFields[element] = JSON.parse(entityFields[element]);
				});
				// Update fieldConfigs.
				// store.dispatch({
				// 	type: types.ADD_FIELD_FROM_METADATA,
				// 	fieldConfig: fields,
				// });

				const checkJsonEquals = JSON.stringify(store.getState().modalState.actionConfig.entityFields) === JSON.stringify(entityFields);
				if (checkJsonEquals) {

					// Remove field error.
					store.dispatch({
						type: types.REMOVE_FIELD_ERROR
					});

				} else {
					// Remove field error.
					store.dispatch({
						type: types.REMOVE_FIELD_ERROR
					});

					store.dispatch({
						type: types.SET_ENTITY_FIELDS,
						entityFields: entityFields
					});


					filteredFields = Object.keys(entityFields).reduce(function (filteredFields, key) {
						(entityFields[key].isMandatory.toLowerCase() === 'false') ? optionalFields[key] = entityFields[key].isMandatory
							: requiredFields[key] = entityFields[key].isMandatory;
						return filteredFields;
					}, {});
					!onload ?
						store.dispatch({
							type: types.REMOVE_FIELD_FROM_METADATA,
						})
						: null;

					let filedConfigData: IFieldConfig[] = [];
					Object.keys(entityFields).map((val, index) => {
						filedConfigData.push(
							{
								FieldName: val,
								FieldValue: '',
								FieldType: entityFields[val].fieldType,
								ValueType: entityFields[val].valueType,
								FieldRequired: entityFields[val].isMandatory.toLowerCase() === 'true',
								FriendlyName: entityFields[val].friendlyName,
								LookupEntityReference: entityFields[val].referenceEntity,
								ValueOptions: entityFields[val].valueOptions,
								ValueOptionsFieldValue: entityFields[val].valueOptionsFieldValue
							}
						);

						// EntityFields and fieldConfigs are two different state variables. 
						// This function helps to keep both of them at sync.
						// Executed here to set field values after fetching it from api.
						// ActionHelper.updateFieldName(index, val.toString());

					});

					// Update fieldConfigs.
					store.dispatch({
						type: types.ADD_FIELD_FROM_METADATA,
						fieldConfig: filedConfigData,
					});

					// Object.keys(requiredFields).map((val, index) => {
					// 	// EntityFields and fieldConfigs are two different state variables. 
					// 	// This function helps to keep both of them at sync.
					// 	// Executed here to set field values after fetching it from api.
					// 	ActionHelper.updateFieldName(index, val.toString());

					// });

				}


			} else {
				// Set field error in the state
				Object.keys(entityFields).map((val, index) => {

					store.dispatch({
						type: types.ADD_FIELD_ERROR,
						errorTitle: val,
						errorMessage: entityFields[val],
					});

				});


			}

			ModalHelper.scrollToBottom();

			return store.getState().modalState.actionConfig.entityFields;
		})
	}

	// Fetch views for the selected entity
	public static loadEntityViews = (entity?: string, onload?: boolean, fields?: IFieldDictionary): Promise<any> => {
		return getEntityViewsFromService(entity).then((entityViews: any) => {

			// Filter fields by requiredFields
			let requiredFields = {};
			let optionalFields = {};
			var filteredFields;
			let entityViewsClone = {};

			// If there is no error fetching the entity-related fields
			if (!entityViews.Error && entityViews.Error !== '') {

				Object.keys(entityViews.entityViewsMetadata).forEach(element => {
					entityViewsClone[element] = JSON.parse(entityViews.entityViewsMetadata[element]);
				});
				// Update fieldConfigs.
				// store.dispatch({
				// 	type: types.ADD_FIELD_FROM_METADATA,
				// 	fieldConfig: fields,
				// });

				const checkJsonEquals = JSON.stringify(store.getState().modalState.actionConfig.enityViews) === JSON.stringify(entityViews);
				if (checkJsonEquals) {

					// Remove field error.
					store.dispatch({
						type: types.REMOVE_FIELD_ERROR
					});

				} else {

					// Remove field error.
					store.dispatch({
						type: types.REMOVE_FIELD_ERROR
					});

					let entityViewsKeyText = [];
					Object.keys(entityViewsClone).map((val, index) => {
						entityViewsKeyText.push(
							{
								key: val,
								text: JSON.stringify(entityViewsClone[val])
							}
						);
					});
					store.dispatch({
						type: types.SET_ENTITY_VIEWS,
						entityViews: entityViewsKeyText
					});

					let isGetRecords: boolean = store.getState().modalState.actionConfig.action.ActionType.NameType.toLowerCase() === "get records";
					if (isGetRecords) {
						let action = store.getState().modalState.actionConfig.action;
						let viewsValue = action.Properties.filter(y => y.Name.toLowerCase() === "views")[0].Value;
						let selectedLayoutView = null;
						if (entityViewsKeyText.filter(x => x.key === viewsValue).length)
							selectedLayoutView = JSON.parse(entityViewsKeyText.filter(x => x.key === viewsValue)[0].text).layoutjson ?
								JSON.parse(JSON.parse(entityViewsKeyText.filter(x => x.key === viewsValue)[0].text).layoutjson).Rows[0].Cells :
								[];

						store.dispatch({
							type: types.SET_IS_PROPERTY_CHANGED,
							value: true
						});

					}

					filteredFields = Object.keys(entityViews).reduce(function (filteredFields, key) {
						(entityViews[key].isMandatory.toLowerCase() === 'false') ? optionalFields[key] = entityViews[key].isMandatory
							: requiredFields[key] = entityViews[key].isMandatory;
						return filteredFields;
					}, {});
					!onload ?
						store.dispatch({
							type: types.REMOVE_FIELD_FROM_METADATA,
						})
						: null;

					// let filedConfigData: IFieldConfig[] = [];
					// Object.keys(entityViews).map((val, index) => {
					// 	filedConfigData.push(
					// 		{
					// 			FieldName: val,
					// 			FieldValue: '',
					// 			FieldType: entityViews[val].fieldType,
					// 			ValueType: entityViews[val].valueType,
					// 			FieldRequired: entityViews[val].isMandatory.toLowerCase() === 'true',
					// 			FriendlyName: entityViews[val].friendlyName,
					// 			LookupEntityReference: entityViews[val].referenceEntity,
					// 			ValueOptions: entityViews[val].valueOptions
					// 		}
					// 	);

					// 	// EntityFields and fieldConfigs are two different state variables. 
					// 	// This function helps to keep both of them at sync.
					// 	// Executed here to set field values after fetching it from api.
					// 	// ActionHelper.updateFieldName(index, val.toString());

					// });

					// Update fieldConfigs.
					// store.dispatch({
					// 	type: types.ADD_FIELD_FROM_METADATA,
					// 	fieldConfig: filedConfigData,
					// });

					// Object.keys(requiredFields).map((val, index) => {
					// 	// EntityFields and fieldConfigs are two different state variables. 
					// 	// This function helps to keep both of them at sync.
					// 	// Executed here to set field values after fetching it from api.
					// 	ActionHelper.updateFieldName(index, val.toString());

					// });

				}


			} else {
				// Set field error in the state
				Object.keys(entityViews).map((val, index) => {

					store.dispatch({
						type: types.ADD_FIELD_ERROR,
						errorTitle: val,
						errorMessage: entityViews[val],
					});

				});


			}

			ModalHelper.scrollToBottom();

			return store.getState().modalState.actionConfig.entityViews;
		})
	}

	public static shouldOverwriteOutputName = (name: string, previousLabel: string): boolean => {
		return !name || !name.length || name === previousLabel || name === 'AnswerValue';
	};

}


// WEBPACK FOOTER //
// ./source/ts/helpers/actions.ts